module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_entry-fb98a1ba5e35132e7295b1dabd98fb1f.png";